const seria = { t: 'Seria', name: 'seria'}
export default seria